module.exports = __webpack_public_path__ + "img/air-vent-placeholder.fd0441b6.png";